import { UserMinus } from 'lucide-react';
import { useDataProvider } from 'ra-core';
import { type AdminDataProvider } from '../../../api/adminDataProvider';
import { CustomBulkAction } from '../../Moonstar/CustomBulkAction';

export const BulkRemoveRoleUsers = (props: { roleId: number }) => {
  const dataProvider = useDataProvider<AdminDataProvider>();

  return (
    <CustomBulkAction
      mutationFn={(userIds) =>
        dataProvider.removeRoleUsers({
          data: userIds.map((userId) => ({
            roleId: props.roleId,
            userId,
          })),
        })
      }
      label="ra.action.remove"
      variant="destructive"
      buttonIcon={<UserMinus />}
      successMessage="moonstar.roleUsers.remove.successMessage"
    />
  );
};
